var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as Preact from 'preact';
import { Box } from '@mui/material';
import * as ActionBar from './M_ActionBar';
import * as Switch from './A_Switch';
import { SquareFoot } from '@mui/icons-material';
import { IconButton } from '@mui/material';
import { isSmallScreen } from './domain/theme/breakpoints';
import { useTheme } from '@mui/material';
export var Component = function (p) {
    var theme = useTheme();
    var isSmall = isSmallScreen(theme);
    return (Preact.h(ActionBar.Component, { sx: __assign({}, p.sx) },
        Preact.h(Box, { sx: {
                display: 'flex',
                alignItems: 'center',
                height: isSmall ? 'auto' : '48px',
            } },
            Preact.h(IconButton, { size: isSmall ? 'small' : 'medium', color: "secondary", onClick: p.onDimensionsToggle, sx: {
                    '&:hover': {
                        color: 'inherit',
                        backgroundColor: 'inherit',
                    },
                } },
                Preact.h(SquareFoot, null)),
            Preact.h(Switch.Component, { onChange: p.onDimensionsToggle, checked: p.showDimensions }))));
};
Component.displayName = 'ActionBarExplore';
